import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../components/Layout/MainLayout';
import DataCenterCard from '../../components/Dashboard/DataCenterCard';
import { RDCIcon, CDIcon, VDCIcon, FDCIcon } from '../../components/Dashboard/DataCenterIcons';
import { ROUTES } from '../../utils/constants';
import { getMyPermissions } from '../../utils/permissions';

const DashboardPage: React.FC = () => {
  const navigate = useNavigate();
  const role_id = localStorage.getItem("role_id");
  // Any of the FDC workflow permissions (bda/pc_manager/pc/qa/fulfillment/admin) unlocks the FDC tile,
  // in addition to the legacy role_id === '3' check this used to be hardcoded to.
  const hasFdcAccess = role_id === '3' || getMyPermissions().some((p) => p.startsWith('fdc_'));
  
  console.log('Current role_id:', role_id); // Debug log

  const handleCardClick = (path = "", isEnabled = false) => { // Fixed parameter name
    console.log('Card clicked - path:', path, 'isEnabled:', isEnabled); // Debug log
    if (isEnabled && path) {
      navigate(path);
    }
    // If disabled, do nothing
  };

  const dataCenters = [
    {
      id: 'rdc',
      title: 'RDC',
      description: '',
      icon: <RDCIcon />,
      path: ['2', '16', '17'].includes(role_id || '') ? ROUTES.RDC : '',
      enabled: ['2', '16', '17'].includes(role_id || ''),
      disabledMessage: !['2', '16', '17'].includes(role_id || '') ? 'Access restricted for your role' : '',
    },
    // {
    //   id: 'cd',
    //   title: 'CD',
    //   description: '',
    //   icon: <CDIcon />,
    //   path:'', // Only enabled for role_id = 2
    //   enabled: false, // Enabled only for role_id = 2
    //   disabledMessage: 'Under Development',
    // },
    {
      id: 'cd',
      title: 'CD',
      description: '',
      icon: <CDIcon />,
      path: ['8', '2', '16', '17'].includes(role_id || '') ? ROUTES.CD_DASH : '',
      enabled: ['8', '2', '16', '17'].includes(role_id || ''),
      disabledMessage: !['8', '2', '16', '17'].includes(role_id || '') ? 'Access restricted for your role' : '',
    },
    {
      id: 'vdc',
      title: 'VDC',
      description: '',
      icon: <VDCIcon />,
      path: ['2', '16', '17'].includes(role_id || '') ? ROUTES.VDC : '',
      enabled: ['2', '16', '17'].includes(role_id || ''),
      disabledMessage: !['2', '16', '17'].includes(role_id || '') ? 'Access restricted for your role' : '',
    },
    {
      id: 'fdc',
      title: 'FDC',
      description: '',
      icon: <FDCIcon />,
      path: hasFdcAccess ? ROUTES.FDC_PROJECTS : '',
      enabled: hasFdcAccess,
      disabledMessage: hasFdcAccess ? '' : 'Access restricted for your role',
    },
  ];

  console.log('Data centers config:', dataCenters.map(dc => ({
    id: dc.id,
    enabled: dc.enabled,
    path: dc.path
  }))); // Debug log

  return (
    <MainLayout>
      <div style={{
        flex: 1,
        background: 'linear-gradient(135deg, #61A1D4 0%, #4A90C4 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        minHeight: 0,
        overflow: 'hidden'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: '1rem',
          maxWidth: '600px',
          width: '100%',
          flex: '0 0 auto'
        }}>
          {dataCenters.map((dc) => (
            <DataCenterCard
              key={dc.id}
              title={dc.title}
              icon={dc.icon}
              description={dc.description}
              onClick={() => handleCardClick(dc.path, dc.enabled)} // Pass dc.enabled directly
              isEnabled={dc.enabled}
              disabledMessage={dc.disabledMessage}
            />
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default DashboardPage;